  import { Events } from './Events';

/**
 * Gets correct breakpoints from <body> elements :before and :after pseudo elements // needs to be set in css
 * @class
 */

interface Options {
  'resizeThrottle': number,
  'defaultType': string
}

interface BreakpointTypes {
  'bootstrap': string,
  'general': string
}

interface Subscriber {
  subscriber: (newBreakpoint: string, oldBreakpoint: string) => void,
  type: string
}

class Breakpoints {
  private settings: Options;
  private breakpointTypes: BreakpointTypes;
  private resizeTimeout: number;
  private oldBreakpoints: BreakpointTypes;
  private breakpoints: BreakpointTypes;
  private subscribers: Array<Subscriber>;
  private Events;

  constructor(options?: Options) {
    var key: string;

    this.settings = {
      'resizeThrottle': 50,
      'defaultType': 'bootstrap'
    };

    // Default breakpoints if browser doesn't support media queries
    this.breakpointTypes = {
      'bootstrap': 'md',
      'general': 'desktop'
    };

    for (key in this.settings) {
      if (!this.settings.hasOwnProperty(key) && options[key]) {
        this.settings[key] = options[key];
      }
    }

    this.breakpoints = {
      'bootstrap': '',
      'general': ''
    };

    this.oldBreakpoints = {
      'bootstrap': '',
      'general': ''
    };

    this.subscribers = [];
    this._addResizeHandler();

    // trigger once
    this._resized();

    this.Events = Events;
  }

  private _addResizeHandler() {
    var self = this;

    Events.addResizeSubscriber(function () {
      self._resized();
    });
  }

  private _setCurrentBreakpoints() {
    var key: string;

    // Get body:before pseudo selector value
    this.breakpoints.bootstrap = window.getComputedStyle(document.body, ':before').getPropertyValue('content').replace(/"/g, "").replace(/'/g, "");

    // Get body:after pseudo selector value
    this.breakpoints.general = window.getComputedStyle(document.body, ':after').getPropertyValue('content').replace(/"/g, "").replace(/'/g, "");

    for (key in this.breakpoints) {
      if (this.breakpoints.hasOwnProperty(key)) {

        // if breakpoint has changed notify subscribers
        if (this.oldBreakpoints[key] !== this.breakpoints[key]) {
          this._notifyBreakpointChangeSubscribers(key);
          this.oldBreakpoints[key] = this.breakpoints[key];
        }
      }
    }
  }

  private _resized() {
    this._setCurrentBreakpoints();
  }

  private _notifyBreakpointChangeSubscribers(type:string) {
    var i;

    for (i = this.subscribers.length - 1; i >= 0; i--) {
      if (this.subscribers[i].type === type) {
        this.subscribers[i].subscriber(this.breakpoints[type], this.oldBreakpoints[type]); // notify with new and old breakpoint
      }
    }
  }

  /**
   * Get current breakpoint
   * @param  {string} breakpointType - 'general' | 'bootstrap'
   * @return {string} breakpoint
   */
  public getBreakpoint(breakpointType?: string): string {
    if (!breakpointType) {
      breakpointType = this.settings.defaultType;
    }

    return this.breakpoints[breakpointType];
  }

  /**
   * Add subscriber function for changes in breakpoints
   * @param {function} subscriber (newBreakpoint, oldBreakpoint)
   * @param {string} breakpointType - 'general' | 'bootstrap'
   */
  public addChangeSubscriber(subscriber:(newBreakpoint:string, oldBreakpoint:string) => void, type: string) {
    if (typeof subscriber === 'function') {
      this.subscribers.push({
        subscriber: subscriber,
        type: type || this.settings.defaultType
      });
    } else {
      throw new Error('Breakpoints#Subscriber needs to be a function');
    }
  }

  /**
   * remove subscriber function
   * @param {function} subscriber - subscriber to remove
   */
  public removeChangeSubscriber(subscriber: (newBreakpoint: string, oldBreakpoint: string) => void) {
    var i, l;

    for (i = this.subscribers.length - 1; i >= 0; i--) {
      if (this.subscribers[i].subscriber === subscriber) {
        this.subscribers.splice(i, 1);
      }
    }
  }
};
var breakpoints = new Breakpoints();

export { breakpoints as Breakpoints }
